export default "__VITE_ASSET__GcWwL4fk__"